import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeviceDetectorService } from 'ngx-device-detector';

import { APP_TITLE } from '@core/constants';
import { IProperty } from '@shared/models/properties';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  selectPropertiesLoading,
  selectPropertiesResults,
} from '@state/properties/properties.selectors';
import { setAuthModal } from '@state/auth/auth.actions';
// import { selectAuthUser } from '@state/auth/auth.selectors';

import { toggleHomeMapViewAction } from '@state/config/config.actions';
import { selectConfigMapView } from '@state/config/config.selectors';

@UntilDestroy()
@Component({
  selector: 'app-home-map',
  templateUrl: './home-map.component.html',
  styleUrls: ['./home-map.component.scss'],
})
export class HomeMapComponent implements OnInit {
  @ViewChild('listViewContainer') listViewContainer!: ElementRef;

  protected loading = false;
  protected mapView?: boolean;
  protected properties: IProperty[] = [];

  protected token?: string | null;
  // protected page: number = 1;
  public isMobile = false;
  protected windowHeight = window.innerHeight;
  public isLoggedIn = false;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private store: Store<AppState>,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();

    this.route.paramMap.subscribe((params) => {
      // const page = params.get('page');
      // this.page = page && parseInt(page) > 0 ? parseInt(page) : 1;

      const urlPath = this.router.url;
      if (urlPath.includes('/auth/password-reset')) {
        this.store.dispatch(setAuthModal({ authModal: 'reset-password' }));
      }

      this.updateTitle();
    });

    this.store
      .select(selectConfigMapView)
      .pipe(untilDestroyed(this))
      .subscribe((mapView) => (this.mapView = mapView));

    this.store
      .select(selectPropertiesLoading)
      .pipe(untilDestroyed(this))
      .subscribe((loading) => (this.loading = loading));

    this.store
      .select(selectPropertiesResults)
      .pipe(untilDestroyed(this))
      .subscribe((properties) => {
        this.properties = properties || [];
        this.changeDetectorRef.detectChanges();
      });

    // TODO: remove this since We are using AuthGuard on the HomeModule routes so this check is not needed
    // this.store
    //   .select(selectAuthUser)
    //   .pipe(untilDestroyed(this))
    //   .subscribe((user) => {
    //     this.isLoggedIn = !!user;
    //     if (!this.isLoggedIn) {
    //       this.router.navigate(['/lp']);
    //     }
    //   });
  }

  toggleMapView(): void {
    this.store.dispatch(toggleHomeMapViewAction());
  }

  updateTitle(): void {
    if (this.token) {
      this.titleService.setTitle(APP_TITLE('Password reset'));
    } else {
      this.titleService.setTitle(APP_TITLE('Welcome'));
    }
    // } else if (this.page === 1) {
    //   this.titleService.setTitle(APP_TITLE('Welcome'));
    // } else {
    //   this.titleService.setTitle(APP_TITLE(`Welcome | Page ${this.page}`));
    // }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (event.target && event.target instanceof Window)
      this.windowHeight = event.target.innerHeight;
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event: Event): void {
    if (event.target && event.target instanceof Window)
      this.windowHeight = event.target.innerHeight;
    if (
      !this.mapView &&
      (screen?.orientation?.type || '').includes('landscape')
    ) {
      this.store.dispatch(toggleHomeMapViewAction());
    }
  }

  scrollToTop(): void {
    if (this.isMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (this.listViewContainer) {
      this.listViewContainer.nativeElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }
}
